import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useActiv8TagsOptions = () => {
  const localTags = useSelector((state) => state.activ8.localTags);
  const tags = useSelector((state) => state.activ8.tags);

  const tagsOptions = useMemo(() => {
    return [...tags, ...localTags]
      .map((tag) => ({ value: tag, label: tag }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [tags, localTags]);

  return tagsOptions;
};

export default useActiv8TagsOptions;
